import { useEffect, useState } from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import BackButton from "../../../../components/backButton/BackButton";
import { Icon } from "../../../../components/icon/Icon";
import Status from "../../../../enums/Status";
import IInviteRecord from "../../../../models/invite/IInviteRecord";
import inviteService from "../../../../services/inviteService";
import InviteList from "./InviteList";

export const Invites = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [invites, setInvites] = useState<IInviteRecord[]>([]);
    const [status, setStatus] = useState<Status>(Status.LOADING);

    useEffect(() => {
        fetchInvites(setInvites, setStatus);
    }, []);

    return (
        <Container className="py-3">
            <Row className="justify-content-center">
                <Col lg={10}>
                    <Card className="shadow">
                        <Card.Body>
                            <Card.Title className="d-flex align-items-center mb-3">
                                <BackButton path="/it" />
                                <span>
                                    {t("it.invite.history.title")}
                                </span>
                            </Card.Title>

                            <Row className="align-items-center mb-3">
                                <Col>
                                    <p className="mb-0 text-muted">
                                        {t("it.invite.history.description")}
                                    </p>
                                </Col>

                                <Col xs="auto">
                                    <Button variant="primary" onClick={() => navigate("/it/invite")}>
                                        <Icon iconName="Plus" endMargin={1} />
                                        {t("it.invite.history.newInvite")}
                                    </Button>
                                </Col>
                            </Row>
                            <InviteList invites={invites} status={status} />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

async function fetchInvites(
    setInvites: (invites: IInviteRecord[]) => void,
    setStatus: (status: Status) => void
) {
    setStatus(Status.LOADING);

    try {
        const invites = await inviteService.getInvites();
        setInvites(invites);
        setStatus(Status.LOAD_SUCCESS);
    } catch {
        setStatus(Status.LOAD_ERROR);
    }
}